import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { api } from '../api.js';

const STEPS = [
  { key: 'solicitado', label: 'Solicitado' },
  { key: 'confirmado', label: 'Confirmado' },
  { key: 'en_preparacion', label: 'En preparación' },
  { key: 'listo', label: 'Listo' },
  { key: 'entregado', label: 'Entregado' },
];

const fmtOpts = (o) => Object.entries(o || {}).map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(', ') : v}`).join(' · ');
const fmtDate = (iso) => new Date(iso).toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' });

export default function SeguimientoPedido() {
  const [params] = useSearchParams();
  const [codigo, setCodigo] = useState(params.get('codigo') || '');
  const [telefono, setTelefono] = useState(params.get('telefono') || '');
  const [order, setOrder] = useState(null);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const buscar = async (e) => {
    e.preventDefault();
    setErr('');
    if (!codigo.trim() || !telefono.trim()) return setErr('Indica el código de pedido y el teléfono con el que lo hiciste.');
    setLoading(true);
    setOrder(null);
    try {
      const res = await api.trackOrder(codigo.trim(), telefono.trim());
      setOrder(res);
    } catch (e2) { setErr(e2.message); }
    setLoading(false);
  };

  const stepIndex = order ? STEPS.findIndex((s) => s.key === order.estado) : -1;

  return (
    <div className="page narrow">
      <div className="page-head">
        <p className="kicker" style={{ justifyContent: 'center' }}>Seguimiento</p>
        <h1>¿Cómo va tu pedido?</h1>
        <p>Indica el código que te dimos al pedir y el teléfono que usaste.</p>
      </div>

      <form className="checkout-form" onSubmit={buscar}>
        <label>Código de pedido
          <input value={codigo} onChange={(e) => setCodigo(e.target.value)} placeholder="KB-2026-0001" />
        </label>
        <label>Teléfono
          <input value={telefono} onChange={(e) => setTelefono(e.target.value)} placeholder="624 32 28 77" />
        </label>
        {err && <p className="form-err">{err}</p>}
        <button className="btn btn--primary btn--block" disabled={loading}>{loading ? 'Buscando…' : 'Consultar'}</button>
      </form>

      {order && (
        <div className="tracker">
          <div className="tracker-head">
            <h3>Pedido {order.codigo}</h3>
            <span>{order.total.toFixed(2)} €</span>
          </div>

          {order.estado === 'cancelado' ? (
            <p className="tracker-cancelled">Este pedido ha sido cancelado. Si tienes dudas, escríbenos por WhatsApp.</p>
          ) : (
            <div className="tracker-steps">
              {STEPS.map((s, i) => (
                <div key={s.key} className={`tracker-step ${i < stepIndex ? 'done' : ''} ${i === stepIndex ? 'current' : ''}`}>
                  <div className="tracker-dot" />
                  <span>{s.label}</span>
                </div>
              ))}
            </div>
          )}

          <p>
            {order.tipoEntrega === 'envio' ? 'Envío' : 'Recogida'} previsto para el <b>{fmtDate(order.fechaEntrega)}</b>
            {order.ventana && <> · franja {order.ventana} h</>}
          </p>

          <div className="tracker-items">
            {order.items.map((i, idx) => (
              <div key={idx}>
                <span>{i.cantidad}× {i.nombre}{fmtOpts(i.opcionesElegidas) && ` (${fmtOpts(i.opcionesElegidas)})`}{i.textoPersonalizado && ` · "${i.textoPersonalizado}"`}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
